var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import DataForm from "~/components/common/data-form.vue";
import { SystemToolsService } from "~/services/domain-service/system-tools.service";
import FileUpload from "~/components/common/file-upload.vue";
var SystemLog = /** @class */ (function (_super) {
    __extends(SystemLog, _super);
    function SystemLog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stypeList = [{
                stypeName: "自然人",
                stypeValue: 1
            }, {
                stypeName: "企业",
                stypeValue: 2
            }];
        _this.namePrompt = "姓名";
        _this.idPrompt = "身份证";
        _this.prevUrl = "";
        _this.nextUrl = "";
        _this.totalNumber = 0;
        _this.currentNum = 0;
        _this.selectedRow = {};
        _this.showSMData = 5;
        _this.fileList = [];
        _this.queryLoading = false;
        _this.queryParam = {
            stype: 1,
            name: "",
            id: ""
        };
        _this.queryDetailParam = {
            stype: 1,
            name: "",
            id: "",
            pageNum: 1,
            url: "",
            hfApiCallType: "ALL"
        };
        _this.riskInfoSummaryDefault = {
            zhixing: {
                num: 0
            },
            shixin: {
                num: 0
            },
            xiangao: {
                num: 0
            },
            xianchu: {
                num: 0
            },
            caipan: {
                num: 0
            },
            shenpan: {
                num: 0
            },
            zuifan: {
                num: 0
            },
            weifa: {
                num: 0
            },
            qianshui: {
                num: 0
            },
            feizheng: {
                num: 0
            },
            zhongben: {
                num: 0
            },
            zhixingsf: {
                num: 0
            },
        };
        _this.dialog = {
            zhixing: false,
            shixin: false,
            xiangao: false,
            xianchu: false,
            caipan: false,
            shenpan: false,
            zuifan: false,
            weifa: false,
            qianshui: false,
            feizheng: false,
            zhongben: false,
            zhixingsf: false,
            uploadFile: false
        };
        _this.riskInfoSummary = _this.riskInfoSummaryDefault;
        _this.dataList = [];
        return _this;
    }
    SystemLog.prototype.stypeChange = function () {
        if (2 === this.queryParam.stype) {
            this.namePrompt = "企业全称";
            this.idPrompt = "统一社会信用代码";
        }
        else {
            this.namePrompt = "姓名";
            this.idPrompt = "身份证";
        }
        this.resetParams();
    };
    SystemLog.prototype.refreshData = function () {
        var _this = this;
        if (this.queryParam.name === "" || this.queryParam.id === "") {
            this.$alert(this.namePrompt + " 与 " + this.idPrompt + " 不能为空", "提示", {
                confirmButtonText: "确定"
            });
            return;
        }
        this.dataList = [];
        this.totalNumber = 0;
        this.currentNum = 0;
        this.systemToolsService
            .queryRiskInfoMixed(this.queryParam)
            .subscribe(function (data) {
            _this.riskInfoSummary = data.recordNumber;
            _this.dataList = data.detail;
            _this.prevUrl = data.prevUrl;
            _this.nextUrl = data.nextUrl;
            _this.totalNumber = data.total;
            _this.currentNum = 1;
        });
    };
    SystemLog.prototype.handleResetForm = function () {
        this.queryParam.stype = 1;
        this.resetParams();
    };
    SystemLog.prototype.resetParams = function () {
        this.queryParam.name = "";
        this.queryParam.id = "";
        this.riskInfoSummary = this.riskInfoSummaryDefault;
        this.dataList = [];
        this.prevUrl = "";
        this.nextUrl = "";
        this.totalNumber = 0;
        this.currentNum = 0;
        this.selectedRow = {};
    };
    SystemLog.prototype.emitViewDetail = function (row) {
        console.log("查看详情  ", row);
        this.selectedRow = row;
        switch (row.callType) {
            case "ZHIXING":
                this.dialog.zhixing = true;
                break;
            case "SHIXIN":
                this.dialog.shixin = true;
                break;
            case "XIANGAO":
                this.dialog.xiangao = true;
                break;
            case "XIANCHU":
                this.dialog.xianchu = true;
                break;
            case "CAIPAN":
                this.dialog.caipan = true;
                break;
            case "SHENPAN":
                this.dialog.shenpan = true;
                break;
            case "ZUIFAN":
                this.dialog.zuifan = true;
                break;
            case "WEIFA":
                this.dialog.weifa = true;
                break;
            case "QIANSHUI":
                this.dialog.qianshui = true;
                break;
            case "FEIZHENG":
                this.dialog.feizheng = true;
                break;
            case "ZHONGBEN":
                this.dialog.zhongben = true;
                break;
            case "ZHIXINGSF":
                this.dialog.zhixingsf = true;
                break;
            default:
                break;
        }
    };
    SystemLog.prototype.prevClick = function () {
        console.log("上一页");
        if (this.prevUrl === "") {
            return;
        }
        this.queryRiskFxContent(this.prevUrl, -1);
    };
    SystemLog.prototype.nextClick = function () {
        var _this = this;
        console.log("下一页");
        if (this.nextUrl === "") {
            return;
        }
        this.$confirm('此操作会产生查询计费，请核实并确认。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.queryRiskFxContent(_this.nextUrl, 1);
        }).catch(function () {
            console.log("取消");
        });
    };
    SystemLog.prototype.queryRiskFxContent = function (url, offsex) {
        var _this = this;
        this.queryDetailParam.url = url;
        this.queryDetailParam.pageNum = this.queryDetailParam.pageNum + offsex;
        this.queryDetailParam.stype = this.queryParam.stype;
        this.queryDetailParam.name = this.queryParam.name;
        this.queryDetailParam.id = this.queryParam.id;
        this.systemToolsService
            .queryRiskFxContent(this.queryDetailParam)
            .subscribe(function (data) {
            if (!data)
                return;
            _this.dataList = data.detail;
            _this.prevUrl = data.prevUrl;
            _this.nextUrl = data.nextUrl;
            _this.currentNum = data.currentPage;
        });
    };
    SystemLog.prototype.batchQueryRiskInfo = function () {
        this.dialog.uploadFile = true;
    };
    SystemLog.prototype.close = function () {
        var upload = this.$refs["upload_risk_info"];
        upload.reset();
        this.dialog.uploadFile = false;
    };
    SystemLog.prototype.commit = function () {
        var _this = this;
        if (this.fileList.length === 0) {
            this.$message("请上传导入文件");
            return;
        }
        this.queryLoading = true;
        console.log(this.fileList[0].response.id);
        var query = {
            fileId: this.fileList[0].response.id
        };
        this.close();
        this.systemToolsService
            .downloadRiskInfo(query)
            .subscribe(function (data) {
            _this.$common.downloadFile(data.url);
            _this.queryLoading = false;
        }, function (err) {
            _this.queryLoading = false;
        });
    };
    __decorate([
        Dependencies(SystemToolsService)
    ], SystemLog.prototype, "systemToolsService", void 0);
    SystemLog = __decorate([
        Auth(2402),
        Layout("workspace"),
        Component({
            components: {
                FileUpload: FileUpload,
                DataForm: DataForm
            }
        })
    ], SystemLog);
    return SystemLog;
}(Vue));
export default SystemLog;
